const state = {
	// 语言环境
	locale: 'zh-CN',
	// 黑色主题，1是true，0是false
	darkTheme: 0
}

const getters = {
	locale: state => {
		let locale = localStorage.getItem('profile-locale');
		if (locale != null) {
			state.locale = locale;
		} else {
			localStorage.setItem('profile-locale', 'zh-CN');
			state.locale = 'zh-CN';
		}
		return state.locale;
	},
	darkTheme: state => {
		let darkTheme = localStorage.getItem('profile-darkTheme');
		if (darkTheme != null) {
			state.darkTheme = darkTheme;
		} else {
			localStorage.setItem('profile-darkTheme', 0);
			state.darkTheme = 0;
		}
		return state.darkTheme;
	}
}

const actions = {
	localeHandler(context, payload){
		context.commit('localeHandler', payload);
	},
	darkThemeHandler(context, payload){
		context.commit('darkThemeHandler', payload);
	}
}

const mutations = {
	localeHandler(state, locale){
		localStorage.setItem("profile-locale", locale);
		state.locale = locale;
		if (state.user != null) {
			state.user.locale = locale;
		}
	},
	darkThemeHandler(state, darkTheme){
		localStorage.setItem("profile-darkTheme", darkTheme);
		state.darkTheme = darkTheme;
		if (state.user != null) {
			state.user.darkTheme = darkTheme;
		}
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user/index.js